<template>
  <div class="account-info-container">
    <header-back
      :title="headerTitTxt"
      go-path="/organization/index"
    />
    <template v-if="!isTrueNameEdit">
      <cube-form class="account-info-box">
        <cube-form-item class="account-item">
          <span class="item-label">{{ $t('message["665"]') }}</span>
          <a
            href="javascript:;"
            class="a-item-cell"
            @click="editName"
          > {{ user.truename }}<i class="cubeic-arrow" /></a>
        </cube-form-item>
        <template v-if="!$isDingDing">
          <cube-form-item class="account-item">
            <span class="item-label">{{ $t('message["1116"]') }}</span>
            <template>
              <router-link
                v-if="user.mobile"
                class="a-item-cell"
                :to="{ name: 'ModifyPhone', query: {mobile: user.mobile }}"
              >
                {{ user.mobile }}<i class="cubeic-arrow" />
              </router-link>
              <router-link
                v-else
                class="a-item-cell"
                :to="{name: 'PersonPhone'}"
              >
                <span>{{ $t('message["1260"]') }}</span><i class="cubeic-arrow" />
              </router-link>
            </template>
          </cube-form-item>
          <cube-form-item class="account-item">
            <span class="item-label">{{ $t('message["1505"]') }}</span>
            <template>
              <router-link
                v-if="user.email"
                class="a-item-cell"
                :to="{ name: 'ModifyEmail', query: {email: user.email }}"
              >
                {{ user.email }}<i class="cubeic-arrow" />
              </router-link>
              <router-link
                v-else
                class="a-item-cell"
                :to="{name: 'SetEmail'}"
              >
                <span>{{ $t('message["1260"]') }}</span><i class="cubeic-arrow" />
              </router-link>
            </template>
          </cube-form-item>
          <cube-form-item class="account-item">
            <span class="item-label">{{ $t('message["200"]') }}</span>
            <template>
              <span
                v-if="user.username"
                class="a-item-cell"
                to="/account/modifyemail"
              >
                {{ user.username }}
              </span>
              <router-link
                v-else
                class="a-item-cell"
                :to="{name: 'PersonAcount'}"
              >
                <span>{{ $t('message["1263"]') }}</span><i class="cubeic-arrow" />
              </router-link>
            </template>
          </cube-form-item>
          <cube-form-item class="account-item">
            <span class="item-label">{{ $t('message["632"]') }}</span>
            <template>
              <router-link
                v-if="user.password"
                class="a-item-cell"
                to="/account/modifypwd"
              >
                ********<i class="cubeic-arrow" />
              </router-link>
              <router-link
                v-else
                class="a-item-cell"
                :to="{name: 'PersonAcount'}"
              >
                <span>{{ $t('message["1263"]') }}</span><i class="cubeic-arrow" />
              </router-link>
            </template>
          </cube-form-item>
          <cube-form-item class="account-item">
            <span class="item-label">{{ $t('message["720"]') }}</span>
            <template>
              <span
                v-if="user.bind_qiwei *1 !== 0 "
                class="a-item-cell"
              >
                <template v-if="user.bindQiweiInfo && user.bindQiweiInfo.length> 0">
                  <em
                    v-for="item in user.bindQiweiInfo"
                    :key="item.id"
                    class="user-item user-item2 border-bottom-1px"
                  >
                    <!-- {{ item.bind_info.name }} -->
                    <div
                      v-if="$store.state.qwWork === 'isWxWork'"
                      class="iframe-qw-name"
                    >{{ item.bind_info.userid }}</div>
                    <iframe
                      v-else
                      class="iframe-qw-name"
                      :src="item.iframeUrl"
                      scrolling="no"
                    />
                    <em style="font-size: 14px;">{{ item.bind_info.corp_full_name }}</em>
                  </em>
                </template>
              </span>
              <span
                v-else
                class="a-item-cell"
              >
                <span>{{ $t('message["1260"]') }}</span>
              </span>
            </template>
          </cube-form-item>
        </template>
        <cube-form-item
          v-if="user.bind_dingding *1 === 1"
          class="account-item"
        >
          <span class="item-label">{{ $t('message["238"]') }}</span>
          <template>
            <span
              v-if="user.bindDingdingInfo && user.bindDingdingInfo.length > 0"
              class="a-item-cell"
            >
              <em
                v-for="item in user.bindDingdingInfo "
                :key="item.id"
                class="user-item user-item2 border-bottom-1px"
              >
                <div class="iframe-qw-name">{{ item.bind_info.name }}</div>
                <em>{{ item.bind_info.corp_full_name }}</em>
              </em>
            </span>
          </template>
        </cube-form-item>
        <cube-form-item
          v-if="!$isDingDing"
          class="account-item"
        >
          <span class="item-label">{{ $t('message["391"]') }}</span>
          <template>
            <span
              v-if="user.bind_gcw *1 !== 0 "
              class="a-item-cell"
              @click="unbindGc"
            >
              <template v-if="user.bindGcwInfo">
                {{ user.bindGcwInfo.bind_info.name }}
              </template>
              <i class="cubeic-arrow" />
            </span>
            <span
              v-else
              class="a-item-cell"
              @click="bindGc"
            >
              <span>{{ $t('message["1260"]') }}</span>
              <i class="cubeic-arrow" />
            </span>
          </template>
        </cube-form-item>
        <cube-form-item class="account-item">
          <span class="item-label">{{ langTxt.langTit }}</span>
          <a
            class="a-item-cell"
            href="javascript:;"
            @click="showPicker"
          >
            {{ langTxt.langIcon }}<i class="cubeic-arrow" />
          </a>
        </cube-form-item>
      </cube-form>
      <div
        v-if="!$isDingDing"
        class="out-btn-box"
      >
        <cube-button
          :light="true"
          @click="logout"
        >
          {{ $t('message["1236"]') }}
        </cube-button>
      </div>
    </template>
    <template v-if="isTrueNameEdit">
      <cube-form
        :model="model"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
        @reset="resetHandler"
      >
        <div class="pro-name-count">
          <cube-form-item :field="fields[0]" />
          <em>{{ model.truename ? (10-model.truename.length) : 10 }}</em>
        </div>
        <div class="form-btn-box">
          <cube-button
            :light="true"
            type="reset"
          >
            {{ $t('message["896"]') }}
          </cube-button>
          <cube-button
            type="submit"
            :primary="true"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </div>
      </cube-form>
    </template>
  </div>
</template>
<script>
import HeaderBack from '@/components/mobile/HeaderBack'
import { mapActions, mapState } from 'vuex'
import { setAuth, getLang, clearStorage } from '@/lib/storage'
export default {
  components: {
    HeaderBack
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      isTrueNameEdit: false,
      model: {
        truename: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'truename',
          label: this.$t('message["665"]'),
          props: {
            placeholder: this.$t('message["751"]'),
            maxlength: 10
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'inputValue2',
          label: 'sxx',
          props: {
            placeholder: this.$t('message["751"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/accountInfo', ['loadingDetails', 'accountDetail']),
    user () {
      const { accountDetail = {} } = this
      const { group = {} } = accountDetail
      const groups = []
      for (let i in group) {
        groups.push(group[i])
      }
      accountDetail.groups = groups.join(' ')
      return accountDetail
    },
    headerTitTxt () {
      return this.$t('message["365"]')
    },
    lang () {
      return this.getLang()
    },
    langTxt () {
      const { lang } = this
      const isZh = lang === 'zh'
      return {
        langTit: isZh ? '语言' : 'Language',
        langIcon: isZh ? '简体中文' : 'English'
      }
    },
    langList () {
      return [{ text: '简体中文', value: 'zh' }, { text: 'English', value: 'en' }]
    },
    pickerTit () {
      return this.lang === 'zh' ? '语言' : 'Language'
    }
  },
  async mounted () {
    const chain = await this.fetchAccountInfoDatas()
    chain
      .onSuccess(res => {
        this.model.truename = this.user.truename
        document.title = this.$t('message["1572"]')
      })
      .fetch()
  },
  methods: {
    ...mapActions('account/accountInfo', ['fetchAccountInfoDatas', 'ajaxEditTruename', 'unBindGc']),
    getLang,
    changeLanguage (type) {
      this.$getLanguage()
    },
    async submitHandler (e) {
      const chain = await this.ajaxEditTruename()
      chain.params(this.model)
        .onSuccess(raw => {
          this.user.truename = this.model.truename
          this.isTrueNameEdit = false
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    logout () {
      let Authorization = ''
      setAuth(Authorization)
      this.$store.commit('setAuth', Authorization)
      this.$store.commit('setRealbackAuth', '')
      clearStorage('realbackAuth')
      clearStorage('realbackCid')
      this.$router.replace({ name: 'AccountLogin' })
    },
    editName () {
      this.isTrueNameEdit = true
    },
    bindGc () {
      this.$createDialog({
        type: 'confirm',
        icon: '',
        title: this.$t('message["14"]'),
        content: this.$t('message["494"]'),
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          window.location.href = this.user.mgcwBindUrl
        },
        onCancel: () => {
        }
      }).show()
    },
    async  unbindGc () {
      const id = this.user.bindGcwInfo.bind_id
      this.$createDialog({
        type: 'confirm',
        icon: '',
        title: this.$t('message["515"]'),
        content: this.$t('message["487"]') + '？',
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        async onConfirm () {
          const chain = await this.unBindGc()
          chain.params({ bindid: id })
            .onSuccess(raw => {
            })
            .onNetSuccess((res) => {
              if (res.data.error !== 104) {
                const toast = this.$createToast({
                  time: 2000,
                  txt: res.data.message || res.data.payload[0].message,
                  type: 'txt'
                })
                toast.show()
              }
            })
            .config({ tip: false })
            .fetch()
        },
        onCancel: () => {
        }
      }).show()
    },
    resetHandler () {
      this.isTrueNameEdit = false
      // this.$router.replace({ name: 'AccountInfo' })
      this.model.truename = this.user.truename
    },
    showPicker () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: this.pickerTit,
          data: [this.langList],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      const type = selectedVal[0] === 'en' ? 'zh' : 'en'
      this.$getLanguage(type)
    },
    cancelHandle () {
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-info-container::v-deep {
    padding-bottom: 60px;
    .cube-form {
      margin-top: 12px;
    }
    .account-item {
      line-height: 56px;
      min-height: 56px;
      font-size: 16px;
      padding-right: 0;
      .unite-btn {
        margin-left: 16px;
      }
      .iframe-qw-name {
        width: 100%;
        height: 24px;
        display: inline;
        vertical-align: middle;
        line-height: 24px;
      }
      .user-item2 {
        padding-bottom: 12px !important;
        em {
          height: 24px;
          line-height: 24px;
          color: #b3b3b3;
          margin-left: 0 !important;
          display: block;
          margin-bottom: 10px;
          margin-top: -6px;

        }
      }
    .cube-form-field {
      display: flex;
      flex-direction: row;
      .item-label {
        display: inline-block;
        width: 24%;
        color: #888;
        font-size: 16px;
      }
      .a-item-cell {
        width: 76%;
        position: relative;
        color: #333;
        font-size: 16px;
        i{
          position:absolute;
          right: 15px;
          color: #ccc;
        }
        span {
          color: #999;
        }
      }
      .user-item {
        width: 100% ;
        display: block;
        font-style: normal;
        padding-right: 15px;
        em{
          margin-left: 10px;
          font-style: normal;
        }
      }
    }
  }
  .out-btn-box {
    height: 70px;
    background: #fff;
    position: fixed;
    left: 0;
    bottom:0;
    right: 0;
    border-top: 1px solid #ebebeb;
    padding: 10px;
    .cube-btn {
      border-radius: 4px;
      border: 1px solid #dbdbdb;
      color: #F57676;
    }
  }
  .pro-name-count {
    position: relative;
    em {
      position: absolute;
      font-style: normal;
      right: 10px;
      top: 15px;
      color: #999;
    }
    .cube-form-item {
      min-height: 56px;
      line-height: 56px;
      .cube-form-label {
        color: #888;
        font-size: 16px;
      }
    }
  }
  }
</style>
